
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { IndividualGroup, UserRole } from 'ah-api-gateways';
import GroupEditModal from '@/app/components/groups/GroupEditModal.vue';
import PermissionsEditor from '../settings/PermissionsEditor.vue';
import WithRequestManager from 'ah-common-lib/src/requestManager/WithRequestManager.vue';
import { useAuthStore } from '@/app/store/authModule';

@Component({
  components: {
    GroupEditModal,
    PermissionsEditor,
  },
})
export default class GroupInfo extends Mixins(WithRequestManager) {
  @Prop({ required: true }) groupId!: string;

  private group: IndividualGroup | null = null;

  requestManagerConfig = {
    exposeToParent: true,
    onRetryFromParentManager: this.onRetryFromParentManager,
  };

  onRetryFromParentManager(k: string) {
    if (k === 'loadGroup') {
      this.onGroupChange();
    }
    if (k === `deleteGroup-${this.groupId}`) {
      this.deleteGroup();
    }
  }

  get authStore() {
    return useAuthStore();
  }

  get groupService() {
    return this.authStore.isClientUser ? this.$services.clientGroup : this.$services.partnerGroup;
  }

  get groupParentId() {
    // Partner group endpoints do not use id in path, when called from a partner user
    return this.authStore.isClientUser ? this.authStore.loggedInIdentity!.client!.id : undefined;
  }

  get groupRole() {
    return this.authStore.isClientUser ? UserRole.CLIENT_INDIVIDUAL : UserRole.PARTNER_AGENT;
  }

  @Watch('groupId', { immediate: true })
  onGroupChange() {
    this.requestManager
      .sameOrCancelAndNew('loadGroup', this.groupService.getGroup(this.groupId, this.groupParentId), this.groupId)
      .subscribe((group) => {
        this.group = group;
      });
  }

  deleteGroup() {
    this.requestManager
      .currentOrNew(`deleteGroup-${this.groupId}`, this.groupService.deleteGroup(this.groupId, this.groupParentId))
      .subscribe(() => {
        this.$emit('group-deleted', this.groupId);
      });
  }
}
